<template>
  <ProgressRing :value="progressPercent(timeleft, time)" :size="60" :thickness="14">
    <p class="text-[22px] font-bold">
      {{ timeleft / 1000 }}
    </p>
  </ProgressRing>
</template>

<script lang="ts" setup>
const props = defineProps({
  time: { type: Number, required: false, default: () => 10 },
  timeleft: { type: Number, required: false, default: () => 10 },
});

const time = computed(() => props.time);
const timeleft = computed(() => props.timeleft);
</script>
